var __TEMP__ = require('./_baseUnset.js');var baseUnset = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_isIndex.js');var isIndex = __REQUIRE_DEFAULT__(__TEMP__);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = basePullAt;
